const skeletonData = [
    {
        id: 1,
        name: "قد",
        unit: "سانتی متر"
    },
    {
        id: 2,
        name: "دور مچ دست",
        unit: "سانتی متر"
    }
]

export default skeletonData